// extracted by mini-css-extract-plugin
export default {"video-link":"q_bD d-flex align-items-center my-2","video-link__link":"q_bF ml-2"};